








































import Vue, { PropType } from 'vue';
import Input from '~/components/builders/Base/Input.vue';
import { CandidateJobBuilder, JobLink } from '~/utils/candidate';
import InfoBox from '../components/InfoBox.vue';

export default Vue.extend({
    name: 'LinksForm',
    components: {
        InfoBox,
        Input,
    },
    props: {
        builder: {
            type: Object as PropType<CandidateJobBuilder>,
            required: true,
        },
    },
    data() {
        return {
            links: this.builder.getLinks(),
        };
    },
    mounted() {
        this.$watch('links', this.builder.watchLinks(), { deep: true });
    },
    methods: {
        handleAddLink() {
            const id = CandidateJobBuilder.generateId();
            this.links.push({
                id,
                name: '',
                value: '',
            });

            this.$nextTick(() => {
                const nameInput = this.$el.querySelector(
                    `input#name-${id}`
                ) as HTMLInputElement | null;
                if (!nameInput) return;
                nameInput.focus();
            });
        },
        handleRemoveLink(id: string) {
            const idx = this.links.findIndex(link => link.id === id);
            idx > -1 && this.links.splice(idx, 1);
        },
    },
    watch: {
        links: {
            deep: true,
            handler(value: JobLink[]) {
                const valid = value.every(link => !!link.name && !!link.value);
                this.$emit('valid', valid);
            },
        },
    },
});
